import script from "./PCDatosAdjuntosEntidad.vue?vue&type=script&setup=true&lang=js"
export * from "./PCDatosAdjuntosEntidad.vue?vue&type=script&setup=true&lang=js"

import "./PCDatosAdjuntosEntidad.vue?vue&type=style&index=0&id=a1221866&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1221866"]])

export default __exports__